import { FILES_URL } from 'constants/config';

export const files = {
  getReceiptUrl: (reference: string, token: string) => {
    return `${FILES_URL}/receipt/${reference}?token=${token}`;
  },
};
